import DeliveryMapPresenter from "../components/delivery-map/presenter/delivery-map.js";

const container = document.querySelector(`.delivery-map-container`);

if (container) {
  const deliveryMapComponent = new DeliveryMapPresenter(container);
  deliveryMapComponent.init();
}

